export default __webpack_public_path__ + "static/media/fw-adele-er-Yellow Gold.e0bc3a05.mp4";